export default __webpack_public_path__ + "static/media/file.6f6e87c2.svg";